export const LayerIndex = {
  Modal: 1020,
  ModalOverlay: 1010,
  Sidebar: 1000,
  SidebarOverlay: 990
};